import { CheckCircle } from 'lucide-react'
import { formatResidentClaimHeaderLabel } from '../../utils/residentHeaderStatus'
import type { ResidentReimbursementReviewSectionProps } from '../../types'
import { primaryEntityActionButtonClass } from '@/components/ui/entityActionButtonClasses'
import { cn } from '@/lib/utils/helpers'
import detailStyles from '@/features/reimbursements/styles/reimbursementDetail.module.css'

/**
 * Angular default-tab “Reimbursement Review” block (aligns with Resident Information section cards).
 * Status line matches Angular `*ngIf="claim_status"` — hidden when claim status is empty.
 */
export function ResidentReimbursementReviewSection({
  roleName,
  residentDefault,
  disabled,
  onReviewReimbursement,
}: ResidentReimbursementReviewSectionProps) {
  const claimStatus = String(residentDefault?.claim_status ?? '').trim()
  const statusText = claimStatus
    ? formatResidentClaimHeaderLabel(roleName, claimStatus)
    : ''

  return (
    <section
      className={`mt-6 ${detailStyles.section}`}
      data-testid="resident-reimbursement-review-section"
    >
      <h2 className={detailStyles.sectionTitle}>
        <span className={detailStyles.sectionTitleIcon} aria-hidden="true">
          <CheckCircle className="h-4 w-4" />
        </span>
        Reimbursement Review
      </h2>
      <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-6">
        <button
          type="button"
          disabled={disabled}
          onClick={onReviewReimbursement}
          data-testid="resident-reimbursement-review-button"
          className={cn(primaryEntityActionButtonClass, 'whitespace-nowrap')}
        >
          Review Reimbursement
        </button>
        {statusText ? (
          <p
            className="break-words text-sm font-semibold text-slate-900"
            data-testid="resident-reimbursement-review-status"
          >
            Review Status : <span className="font-bold text-slate-950">{statusText}</span>
          </p>
        ) : null}
      </div>
    </section>
  )
}

